module.exports = __webpack_public_path__ + "static/media/intro.56bb1f2d.mp3";